import { useQuery } from "@tanstack/react-query";
import { api, withClientTimeout } from "../lib/api";
import type { MarketResearchReview, OutputDocument } from "../../../shared/types";

export type MarketResearchRunOutputResponse = {
  data: {
    review: MarketResearchReview;
    output_document: OutputDocument | null;
  };
};

/**
 * Reads the task-run's canonical research report. This deliberately does not
 * use the legacy research-record or output-rollout routes: the task run owns
 * both authorization and the deterministic canonical output identity.
 */
export function useMarketResearchRunOutput(runId: string | undefined, enabled = true) {
  return useQuery({
    queryKey: ["market-research-run-output", runId],
    queryFn: () => withClientTimeout((signal) => api.get<MarketResearchRunOutputResponse>(`/api/task-runs/${encodeURIComponent(runId!)}/output`, signal)),
    enabled: Boolean(runId) && enabled,
    staleTime: 10_000,
    retry: false,
  });
}
